exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "dv-versicherungsbeitrag-list .header-row{white-space:nowrap}dv-versicherungsbeitrag-list:focus{outline:none}dv-versicherungsbeitrag-list .row-ext-schadennr{width:25%}dv-versicherungsbeitrag-list .row-schadendatum,dv-versicherungsbeitrag-list .row-versicherung{width:10%}dv-versicherungsbeitrag-list .row-beitrag{width:15%}dv-versicherungsbeitrag-list .row-status{width:200px}dv-versicherungsbeitrag-list .row-actions{width:90px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/component/dv-versicherungsbeitrag-list/dv-versicherungsbeitrag-list.scss
// module id = CcdS
// module chunks = 0